import React from 'react';
const cellValue = (clauseSource) => {
    if (clauseSource === undefined)
        return '';
    return (clauseSource.policyCheck || '') + ' ' + (clauseSource.citation || '');
};
const cellValueFormatted = (clauseSource) => {
    if (clauseSource === undefined)
        return React.createElement(React.Fragment, null);
    return React.createElement(React.Fragment, null,
        clauseSource.policyCheck || '',
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("i", null, clauseSource.citation || ''));
};
const modalValueFormatted = (clauseSource) => {
    if (clauseSource === undefined)
        return React.createElement(React.Fragment, null);
    return React.createElement(React.Fragment, null,
        React.createElement("b", null, "Summary"),
        ": \u00A0",
        clauseSource.policyCheck || '',
        React.createElement("br", null),
        React.createElement("b", null, "Citation"),
        ": \u00A0",
        React.createElement("i", null, clauseSource.citation || ''),
        React.createElement("br", null),
        React.createElement("b", null, "Source Text"),
        ": \u00A0",
        clauseSource.source || '',
        React.createElement("br", null),
        React.createElement("b", null, "Confidence"),
        ": \u00A0",
        clauseSource.confidenceScore || '',
        React.createElement("br", null));
};
export default { cellValue, cellValueFormatted, modalValueFormatted };
